import { createElement } from "react";
import React from "react";
import { useCtx } from "./Context.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { createObj, equals } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Role } from "./Shared/SharedModels.jsx";
import { notFoundView, unauthorizedView } from "./Helpers.jsx";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { tokens } from "@fluentui/react-components";
import { Breadcrumb } from "./Breadcrumb.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { View as View_1 } from "./Calendar.jsx";
import { S3UploadTester } from "./Routes.jsx";
import { View as View_2 } from "./Course/CourseView.jsx";
import { View as View_3 } from "./Event/ListEvents.jsx";
import { View as View_4 } from "./Event/EventView.jsx";
import { TrackView } from "./Track/TrackView.jsx";
import { TrackBuilder } from "./Track/TrackBuilder.jsx";
import { unwrap } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { View as View_5 } from "./Track/TrackEnrolledUsers.jsx";
import { EditCourseView } from "./Track/EditCourse.jsx";
import { ListTracks } from "./Track/ListTracks.jsx";
import { AboutUser } from "./UserProfile.jsx";
import { UserFremdrift } from "./UserFremdrift.jsx";
import { View as View_6 } from "./Event/ListCompletedEvents.jsx";
import { WorkplaceTable } from "./Workplaces.jsx";
import { RegionsView } from "./Regions.jsx";
import { TitlesView } from "./Titles.jsx";
import { View as View_7 } from "./Report.jsx";
import { RulePage } from "./Rules/RulePage.jsx";
import { View as View_8 } from "./ApproveUsers.jsx";
import { Documentation } from "./Documentation.jsx";
import { View as View_9 } from "./Home.jsx";

export function View(viewInputProps) {
    let elems_3, elems_2, elems_1;
    const currentPage = viewInputProps.currentPage;
    const ctx = useCtx()[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const requireAdmin = (page) => {
        if (equals(ctx.User.Role, new Role(1, []))) {
            return page();
        }
        else {
            return unauthorizedView();
        }
    };
    const requireAdminOrSelf = (userId, page_1) => {
        if (equals(ctx.User.Role, new Role(1, [])) ? true : (ctx.User.Id === userId)) {
            return page_1;
        }
        else {
            return unauthorizedView();
        }
    };
    return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["width", 100 + "%"]), delay(() => append(singleton(["height", ("calc(" + "100vh - 60px") + ")"]), delay(() => append(singleton(["display", "flex"]), delay(() => {
        let matchValue;
        return append((matchValue = currentPage, (matchValue.tag === 5) ? ((matchValue.fields[0].tag === 2) ? singleton(["justifyContent", "left"]) : singleton(["justifyContent", "center"])) : singleton(["justifyContent", "center"])), delay(() => append(singleton(["backgroundColor", tokens.colorNeutralBackground2]), delay(() => singleton(["overflow", "auto"])))));
    })))))))))], (elems_3 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => {
        let matchValue_1;
        return append((matchValue_1 = screenSize, (matchValue_1.tag === 0) ? singleton(["maxWidth", 98 + "vw"]) : ((matchValue_1.tag === 1) ? singleton(["maxWidth", 98 + "vw"]) : ((currentPage.tag === 1) ? singleton(["maxWidth", 100 + "%"]) : singleton(["maxWidth", 1200])))), delay(() => singleton(["flexGrow", 1])));
    })))], (elems_2 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => ((screenSize.tag === 0) ? singleton(["padding", 0.5 + "rem"]) : ((screenSize.tag === 1) ? singleton(["padding", 0.5 + "rem"]) : singleton(["padding", 1 + "rem"]))))))], (elems_1 = toList(delay(() => {
        let elems;
        return append((equals(screenSize, new ScreenSize(3, [])) ? true : equals(screenSize, new ScreenSize(4, []))) ? singleton(createElement("div", createObj(ofArray([["style", {
            paddingBottom: 1 + "rem",
        }], (elems = [createElement(Breadcrumb, null)], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => {
            const matchValue_3 = currentPage;
            return (matchValue_3.tag === 1) ? singleton(createElement(View_1, null)) : ((matchValue_3.tag === 2) ? singleton(createElement(S3UploadTester, null)) : ((matchValue_3.tag === 3) ? singleton(createElement(View_2, {
                courseId: matchValue_3.fields[0].fields[0],
            })) : ((matchValue_3.tag === 4) ? ((matchValue_3.fields[0].tag === 1) ? singleton(createElement(View_3, {
                queryParams: matchValue_3.fields[0].fields[0],
            })) : singleton(createElement(View_4, {
                eventId: matchValue_3.fields[0].fields[0],
            }))) : ((matchValue_3.tag === 5) ? ((matchValue_3.fields[0].tag === 1) ? singleton(createElement(TrackView, {
                trackId: matchValue_3.fields[0].fields[0],
            })) : ((matchValue_3.fields[0].tag === 2) ? singleton(createElement(TrackBuilder, {
                trackId: unwrap(matchValue_3.fields[0].fields[0]),
            })) : ((matchValue_3.fields[0].tag === 4) ? singleton(requireAdmin(() => createElement(View_5, {
                trackId: matchValue_3.fields[0].fields[0],
            }))) : ((matchValue_3.fields[0].tag === 3) ? singleton(createElement(EditCourseView, null)) : singleton(createElement(ListTracks, null)))))) : ((matchValue_3.tag === 6) ? singleton(requireAdminOrSelf(matchValue_3.fields[0], createElement(AboutUser, {
                userId: matchValue_3.fields[0],
            }))) : ((matchValue_3.tag === 7) ? singleton(requireAdminOrSelf(matchValue_3.fields[0], createElement(UserFremdrift, {
                userId: matchValue_3.fields[0],
            }))) : ((matchValue_3.tag === 8) ? singleton(requireAdminOrSelf(matchValue_3.fields[0], createElement(View_6, {
                userId: matchValue_3.fields[0],
            }))) : ((matchValue_3.tag === 9) ? ((matchValue_3.fields[0].tag === 0) ? singleton(requireAdmin(() => createElement(WorkplaceTable, null))) : ((matchValue_3.fields[0].tag === 1) ? singleton(requireAdmin(() => createElement(RegionsView, null))) : ((matchValue_3.fields[0].tag === 2) ? singleton(requireAdmin(() => createElement(TitlesView, null))) : ((matchValue_3.fields[0].tag === 4) ? singleton(requireAdmin(() => createElement(View_7, null))) : ((matchValue_3.fields[0].tag === 5) ? singleton(requireAdmin(() => createElement(RulePage, null))) : singleton(requireAdmin(() => createElement(View_8, null)))))))) : ((matchValue_3.tag === 10) ? singleton(createElement(Documentation, null)) : ((matchValue_3.tag === 11) ? singleton(notFoundView()) : singleton(createElement(View_9, null))))))))))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

//# sourceMappingURL=CurrentPage.jsx.map
